import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import fuzzy from 'fuzzy';

import environment from '../../relay/environment';
import Vendor from './Vendor';
import styles from './styles.scss';
import VendorListFilters from './VendorListFilters';

class RenderedVendors extends React.Component {
  static propTypes = {
    vendors: PropTypes.arrayOf(PropTypes.object).isRequired,
    activeVendor: PropTypes.string,
  }

  static defaultProps = {
    activeVendor: '',
  }

  componentDidMount() {
    this.scrollToVendor();
  }

  componentDidUpdate() {
    this.scrollToVendor();
  }

  scrollToVendor = () => {
    const node = ReactDom.findDOMNode(this.refs.activeVendor); // eslint-disable-line
    if (node) {
      node.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  }

  render() {
    const { vendors, activeVendor } = this.props;

    return (<div className={styles.listItems}>{vendors.map((vendor) => {
      const { id: vendorId } = vendor;
      const active = vendorId === activeVendor;
      const ref = active ? 'activeVendor' : null;

      return (<Vendor key={vendorId} vendor={vendor} active={active} ref={ref} />);
    })}</div>);
  }
}

@connect(state => ({
  windowHeight: state.Responsive.get('windowHeight'),
}))
class Renderer extends React.Component { // eslint-disable-line
  static propTypes = {
    activeVendor: PropTypes.string,
    loadingEl: PropTypes.element.isRequired,
  }

  static defaultProps = {
    activeVendor: '',
  }

  constructor(props) {
    super(props);

    this.state = {
      vendorFilter: '',
    };
  }

  updateVendorFilter = (e) => {
    const { target: { value: vendorFilter } } = e;
    this.setState({ vendorFilter });
  }

  render() {
    const { activeVendor, loadingEl } = this.props;
    const { vendorFilter } = this.state;
    const updateVendorFilter = this.updateVendorFilter;

    return (<QueryRenderer
      environment={environment}
      query={graphql`
        query VendorListRenderer_VendorList_Query {
          allVendors {
            edges {
              node {
                id,
                name
              }
            }
          }
        }
      `}
      render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          const { allVendors: { edges: vendors } } = props;

          let filteredVendors = vendors.map(({ node }) => node);
          if (vendorFilter) {
            filteredVendors = fuzzy.filter(
              vendorFilter, vendors.map(({ node }) => node), {
                extract: vendor => vendor.name,
              }
            ).map(filteredVendor => filteredVendor.original);
          }

          return (<div>
            <VendorListFilters
              numVendors={vendors.length}
              numFiltered={filteredVendors.length}
              updateFilter={updateVendorFilter}
              filter={vendorFilter}
            />
            <RenderedVendors
              vendors={filteredVendors}
              activeVendor={activeVendor}
            />
          </div>);
        }

        return loadingEl;
      }}
    />);
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Vendors/VendorListRenderer.js